<template>
  <cv-text-input :label="etichetta"
                 :helper-text="suggerimento"
                 :value="modello"
                 :readonly="readonly"
                 @change="cambiaValore"
                 @input="onInput">
    <template v-if="!flg_data_valida" slot="invalid-message">
      {{messaggio_non_valido}}
    </template>
  </cv-text-input>

</template>

<script>
function validatedate(dateString) {
  let dateformat = /^(0?[1-9]|[1-2][0-9]|3[01])[\\/](0?[1-9]|1[0-2])[/]\d{4}$/;

  // Match the date format through regular expression
  if(dateString.match(dateformat)){
    let operator = dateString.split('/');

    // Extract the string into month, date and year
    let datepart = [];
    if (operator.length>1){
      datepart = dateString.split('/');
    }

    let day = parseInt(datepart[0]);
    let month= parseInt(datepart[1]);
    let year = parseInt(datepart[2]);

    // Create list of days of a month
    let ListofDays = [31,28,31,30,31,30,31,31,30,31,30,31];
    if (month===1 || month>2){
      if (day>ListofDays[month-1]){
        ///This check is for Confirming that the date is not out of its range
        return false;
      }
    }else if (month === 2){
      let leapYear = false;
      if ( (!(year % 4) && year % 100) || !(year % 400)) {
        leapYear = true;
      }
      if ((leapYear === false) && (day>=29)){
        return false;
      }else
      if ((leapYear === true) && (day>29)){
        console.log('Formato data non valido in anno bisestile');
        return false;
      }
    }
  }else{
    console.log("Formato data non valido per " + dateString);
    return false;
  }
  return true;
}

export default {
  name: "DataValida",
  props: {
    // value serve perché il chiamante possa usare v-model
    value: String,
    // Etichetta sopra al campo
    etichetta: {
      type: String,
      required: true
    },
    // Messaggio che si mostra all' utente se il formato data non è valido
    messaggio_non_valido: {
      type: String,
      default: "Data non valida",
      required: false
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: function() {
    return {
      // Scrive sotto alla casella un suggerimento per il formato data
      suggerimento: "gg/mm/anno",
      // Valore della data in formato stringa
      modello: this.value,
      // Quando è vero, NON mostra il messaggio, altrimenti comunica all' utente che la data non è valida
      flg_data_valida: true
    }
  },
  methods: {
    cambiaValore: function (nuova_data) {
      console.log(Object.getOwnPropertyNames(nuova_data));
      console.log("cambiaValore - modello " + this.modello);

      this.flg_data_valida = validatedate(this.modello);
    },
    onInput: function (nuova_data) {
      console.log("onInput - nuova_data " + nuova_data);

      this.modello = nuova_data;
      this.$emit('input', nuova_data);
    }
  }
}
</script>

<style scoped>

</style>